if (typeof twilio == 'undefined') {
	var twilio = {};
}

window.dataLayer = window.dataLayer || [];

twilio.analytics = {
	pageView: function(url) {
		this.gtmPageview(url);
	},

	/** Depracated with removal of Mixpanel **/
	event: function() { $.noop(); },
	identify: function() { $.noop(); },
	set: function() { $.noop(); },
	set_once: function() { $.noop(); },
	append: function() { $.noop(); },
	increment: function() { $.noop(); },

	/** VENDOR SPECIFIC FUNCTIONS SHOULD NOT BE CALLED OUTSIDE OF twilio.analytics.* **/
	gtmPageview: function(url) {
		dataLayer.push({ event: 'VPTracker', VPUrl: url, VPTitle: document.title });
	},
	optimizely: function() { $.noop(); }

};

$(function () {
	if (twilio['flag_clear_large_cookies']) {
		var toClear = ['optimizelySegments', 'optimizelyEndUserId', 'optimizelyPendingLogEvents', 'optimizelyBuckets'];
		var options = { domain: '.twilio.com', path: '/' };

		toClear.forEach(function (key) {
			Cookies.remove(key, options);
		});
	}
});
